<div class="loader-overlay">
  <div class="loader-content">
    <img src="/icon_logo_previ.svg" alt="PREVI" class="loader-logo">
  </div>
</div>
